module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    class: ['reservation-modal', 'dark-top'],
    attrs: {
      "large": true
    },
    on: {
      "close": _vm.closeWindow
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Request Refund")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "p-4"
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Channel")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.refundObject.refundChannels.$error
    }
  }, [_c('channel-selector', {
    attrs: {
      "reservation": _vm.getSelectedReservation
    },
    on: {
      "input": _vm.channelChanged
    },
    model: {
      value: (_vm.refundObject.refundChannels),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "refundChannels", $$v)
      },
      expression: "refundObject.refundChannels"
    }
  }), _vm._v(" "), (_vm.$v.refundObject.refundChannels.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.refundObject.refundChannels.required) ? _c('span', [_vm._v("Select one.")]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("When to refund")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.refundObject.isRequest.$error,
      'opacity-50': _vm.disableRefundRequestArea
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center p-2 radius-normal bg-lighter pointer",
    on: {
      "click": function($event) {
        return _vm.clickRefundRequestType(false)
      }
    }
  }, [_c('div', {
    staticClass: "mx-2"
  }, [_c('radio', {
    attrs: {
      "name": "isRequest",
      "disabled": _vm.disableRefundRequestArea,
      "value": false
    },
    on: {
      "input": _vm.$v.refundObject.isRequest.$touch
    },
    model: {
      value: (_vm.refundObject.isRequest),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "isRequest", $$v)
      },
      expression: "refundObject.isRequest"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "darker"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("Refund customer now")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center p-2 radius-normal bg-lighter pointer mt-1",
    on: {
      "click": function($event) {
        return _vm.clickRefundRequestType(true)
      }
    }
  }, [_c('div', {
    staticClass: "mx-2"
  }, [_c('radio', {
    attrs: {
      "name": "isRequest",
      "disabled": _vm.disableRefundRequestArea,
      "value": true
    },
    on: {
      "input": _vm.$v.refundObject.isRequest.$touch
    },
    model: {
      value: (_vm.refundObject.isRequest),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "isRequest", $$v)
      },
      expression: "refundObject.isRequest"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "darker"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("Request refund")])])]), _vm._v(" "), (_vm.$v.refundObject.isRequest.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.refundObject.isRequest.required) ? _c('span', [_vm._v("Select one.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.refundObject.paymentType.$error
    }
  }, [_c('payment-method-picker', {
    attrs: {
      "allowedMethods": _vm.allowdPaymentMethods
    },
    on: {
      "change": _vm.paymentMethodPickerChange
    },
    model: {
      value: (_vm.refundObject.paymentType),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "paymentType", $$v)
      },
      expression: "refundObject.paymentType"
    }
  }), _vm._v(" "), (_vm.$v.refundObject.paymentType.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.refundObject.paymentType.required) ? _c('span', [_vm._v("Select one.")]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Refund Type")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.selectedRefundType.$error,
      'opacity-50': _vm.disableRefundTypeArea
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.getRefundTypes), function(refundType) {
    return _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "refundTypeBtn w-100 btn bg-lightest radius-normal darker bold fs-large",
      class: {
        'selected': _vm.isRefundTypeSelected(refundType),
        'bg-light': _vm.disableRefundTypeArea
      },
      on: {
        "click": function($event) {
          return _vm.selectRefundType(refundType)
        }
      }
    }, [_vm._v(_vm._s(refundType.label))])])
  }), 0), _vm._v(" "), (_vm.$v.selectedRefundType.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.selectedRefundType.required) ? _c('span', [_vm._v("Select one.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.selectedRefundType != null) ? _c('div', {}, [(_vm.selectedRefundType.id == 1) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Percentage or Value")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.selectedRefundType.$error
    }
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "bold mr-2"
  }, [_vm._v("\n                                Value:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.refundObject.amount),
      expression: "refundObject.amount",
      modifiers: {
        "number": true
      }
    }, {
      name: "numFloat",
      rawName: "v-numFloat"
    }],
    staticClass: "glued-right",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.refundObject.amount)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.refundObject, "amount", _vm._n($event.target.value))
      }, function($event) {
        return _vm.debouncedValueChanged()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "glued-left",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "options": _vm.getPercentageOrCurrency
    },
    on: {
      "input": function($event) {
        return _vm.valueTypeChanged($event)
      }
    },
    model: {
      value: (_vm.selectedValueType),
      callback: function($$v) {
        _vm.selectedValueType = $$v
      },
      expression: "selectedValueType"
    }
  })], 1)]), _vm._v(" "), (_vm.$v.selectedRefundType.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.selectedRefundType.isValid) ? _c('span', [_vm._v("Invalid value.")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.selectedRefundType.id == 2) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Reservation Items")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.refundItems.$error
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.calculationResult == null) ? _c('div', {
    staticClass: "w-100 text-center py-4"
  }, [_c('loader')], 1) : _c('div', [(_vm.calculationResult != null) ? _c('reduce-quantity', {
    attrs: {
      "calculations": _vm.calculationResult
    },
    on: {
      "change": function($event) {
        return _vm.requestCalculations()
      }
    },
    model: {
      value: (_vm.refundObject.refundItems),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "refundItems", $$v)
      },
      expression: "refundObject.refundItems"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center p-2 radius-normal bg-lighter pointer",
    on: {
      "click": _vm.toggleReleaseQuantity
    }
  }, [_c('div', {
    staticClass: "mx-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.refundObject.isToReleaseQuantity),
      callback: function($$v) {
        _vm.$set(_vm.refundObject, "isToReleaseQuantity", $$v)
      },
      expression: "refundObject.isToReleaseQuantity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "darker"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("Make refunded items available again")]), _vm._v(" "), _c('div', {
    staticClass: "fs-smaller"
  }, [_vm._v("This will allow to re-sell refunded items")])])]), _vm._v(" "), (_vm.$v.refundItems.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.refundItems.isValid) ? _c('span', [_vm._v("Select at least one item to refund.")]) : _vm._e()]) : _vm._e()], 1)])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Reason")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.$v.refundObject.refundReasonType.$error
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.getRefundReasons,
      "disabled": _vm.disableReasonArea,
      "label": "text",
      "placeholder": "Select reason"
    },
    on: {
      "input": _vm.reasonChanged
    },
    model: {
      value: (_vm.selectedReason),
      callback: function($$v) {
        _vm.selectedReason = $$v
      },
      expression: "selectedReason"
    }
  }), _vm._v(" "), (_vm.refundObject.refundReasonType == 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('label', [_vm._v("Describe the refund reason")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refundObject.reason),
      expression: "refundObject.reason"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.refundObject.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.refundObject, "reason", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$v.refundObject.refundReasonType.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.refundObject.refundReasonType.required) ? _c('span', [_vm._v("Reason is required.")]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Value to Refund")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "fs-large bold dark text-right"
  }, [(_vm.isLoadingCalculations) ? _c('loader') : _c('div', {
    staticClass: "d-flex flex-column"
  }, [(_vm.refundValueProcessed.now != null) ? _c('div', {
    staticClass: "d-flex flex-grow-1 justify-content-end"
  }, [_c('span', [_vm._v("Refund now: " + _vm._s(_vm.formatPrice(_vm.refundValueProcessed.now)) + " €")])]) : _vm._e(), _vm._v(" "), (_vm.refundValueProcessed.later != null) ? _c('div', {
    staticClass: "d-flex flex-grow-1 justify-content-end"
  }, [_c('span', [_vm._v("Refund later: " + _vm._s(_vm.formatPrice(_vm.refundValueProcessed.later)) + " €")])]) : _vm._e()])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "align-items-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "color-6 w-100 text-align-right"
  }, [_vm._v("\n            " + _vm._s(_vm.emailWarningMessage) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    class: {
      'disabled': _vm.isRefundValid == false
    },
    attrs: {
      "type": "button",
      "disabled": _vm.getIsLoadingCalculations
    },
    on: {
      "click": _vm.clickRefund
    }
  }, [_vm._v("Confirm")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a9120ab"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationRefund.vue
// module id = 1832
// module chunks = 0